import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Container,
  IconButton,
  MenuItem,
  TextField,
} from "@mui/material";
import { ConsultantuseAuth } from "../../security/ConsultantUseAuth";

import GetClientAddress from "../../../functions/GetClientAddress";
import { Get_One_From_MongoDB } from "../../api/Get_One_From_MongoDB";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";

import { Get_All_From_MongoDB_With_Search_Prop_In_Array } from "../../api/Get_All_From_MongoDB_With_Search_Prop_In_Array";
import { Get_One_Choose_Fields_From_MongoDB } from "../../api/Get_One_Choose_Fields_From_MongoDB";
import { Get_All_Non_Archived_Attendees_From_Array } from "../../api/Get_All_Non_Archived_Attendees_From_Array";
import { Consultant_Update_To_MongoDB_By_ID } from "../../api/Consultant_Update_To_MongoDB_By_ID";
import { Consultant_SendEndOfYearCommisionEmail } from "../../api/Consultant_SendEndOfYearCommisionEmail";
import { Get_All_Attendees_From_Array } from "../../api/Get_All_Attendees_From_Array";

const EndOfYear = () => {
  const { logoutConsultant } = ConsultantuseAuth();

 
 


  //----------------------------------------------------------

  //Get EC Data
  const [obj_EC, setobj_EC] = useState({});
  useEffect(() => {
    const fetchECData = async () => {
      Get_One_From_MongoDB(
        "IP",
        "EC",
        localStorage.getItem("Consultant_id"),
        setobj_EC,
        logoutConsultant
      );
    };
    fetchECData();
  }, []);
  //Get All ECs if Admin
    const [Arr_ECs, setArr_ECs] = useState([]);
    useEffect(() => {
      if (obj_EC.MetaData?.Admin === "Yes") {
        const fetchAttendeeData = async () => {
          Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort(
            "IP",
            "EC",
            { "MetaData.Agency_id": obj_EC.MetaData?.Agency_id },
            100,
            setArr_ECs,
            {},
            { _id: 1, BasicInfo: 1 },
            logoutConsultant
          );
        };
        fetchAttendeeData();
      }
    }, [obj_EC]);
    console.log("Arr_ECs", Arr_ECs)

  const [obj_Agency, setobj_Agency] = useState({});
    useEffect(() => {
      if (obj_EC.MetaData?.Agency_id && obj_EC.MetaData.Agency_id.length > 0) {
        Get_One_Choose_Fields_From_MongoDB(
          "IP",
          "Agencies",
          obj_EC.MetaData.Agency_id,
          {
            "MetaData.IP_id": 1,
            _id: 1,
            BasicInfo: 1,
          },
          setobj_Agency
        );
      }
    }, [obj_EC]);
    const [obj_IP, setobj_IP] = useState({});
    useEffect(() => {
      if (obj_Agency.MetaData?.IP_id && obj_Agency.MetaData.IP_id.length > 0) {
        Get_One_Choose_Fields_From_MongoDB(
          "Staff",
          "Users",
          obj_Agency.MetaData.IP_id,
          {
            Username: 1,
            _id: 1,
          },
          setobj_IP
        );
      }
    }, [obj_Agency]);


  //Part 1, get bookings data
  const [Arr_Bookings, setArr_Bookings] = useState([]);
  useEffect(() => {
    //See if admin
     if (obj_EC.MetaData?.Admin === "Yes") {
      //Yes Admin
            let Arr_ECs_IDs = Arr_ECs.map((obj) => obj._id);
            Get_All_Attendees_From_Array(
              "Registers_2025",
              "All",
              "IPInfo.EC_ID",
              Arr_ECs_IDs,
              {
                BasicInfo: 1,
                Contacts: 1,
                IPInfo: 1,            OrderInfo: 1,
                SEFProgress: 1,
                VISA: 1,
                SEFInfo: 1,
                Notes: 1,
                SummerArrivalDeparture: 1,
              },
              setArr_Bookings,
              logoutConsultant
            );
          } else {
            //Not Admin
    const fetchAttendeeData = async () => {
       
        Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort(
          "Registers_2025",
          "All",
          {
            "IPInfo.EC_ID": localStorage.getItem("Consultant_id"),
           // "MetaData.Archived": { $ne: "Yes" },
          },
          1000,
          setArr_Bookings,
          {},
          {
            _id: 1,
            BasicInfo: 1,
            OrderInfo: 1,
            Contacts: 1,
            IPInfo: 1,
            SEFProgress: 1,
            VISA: 1,
            SEFInfo: 1,
            Notes: 1,
          },
          logoutConsultant
        );
      
    };
    fetchAttendeeData();
  }
  }, [obj_EC, Arr_ECs]);

  //part 2, get all id's from bookings
  const getCompiledArray = async () => {
    // Wait for the state to update
    return new Promise((resolve) => {
      setTimeout(() => {
        let Arr_Bookingid = Arr_Bookings.map((obj) => obj._id);
        resolve(Arr_Bookingid);
      }, 0);
    });
  };

  //part 3, use the id's from bookings to find all invoices
  const [Arr_Invoices, setArr_Invoices] = useState([]);
  const fetchInvoiceData = async () => {
    const compiledArray = await getCompiledArray();

    Get_All_From_MongoDB_With_Search_Prop_In_Array(
      "Invoices",
      "Xero_2025",
      "Attendees.Attendee_id",
      compiledArray,
      setArr_Invoices,
      logoutConsultant
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      // Part 1: Fetch attendee data
      //await fetchAttendeeData();
      // Part 2: Get all IDs from bookings
      const compiledArray = await getCompiledArray();
      // Part 3: Use the IDs from bookings to find all invoices
      await fetchInvoiceData(compiledArray);
    };
    fetchData();
  }, [Arr_Bookings]);

  //----------------------------------Filter and Sort

  //filter out any onvoice with Paid_Status of "Voided" or "Credited"
  let Arr_Invoices_Filtered = Arr_Invoices.filter(
    (invoice) =>
      invoice.Paid_Status !== "Voided" && invoice.Paid_Status !== "Credited"
  );

  let Arr_Invoices_Filtered_Sorted = React.useMemo(() => {
    let sortableItems = [...Arr_Invoices_Filtered];
    sortableItems.sort((a, b) => {
      if (a.Paid_Status === "Paid" && b.Paid_Status !== "Paid") {
        return 1;
      } else if (b.Paid_Status === "Paid" && a.Paid_Status !== "Paid") {
        return -1;
      } else if (a.Due_Date > b.Due_Date) {
        return 1;
      } else if (a.Due_Date <= b.Due_Date) {
        return -1;
      } else {
        return 0;
      }
    });

    return sortableItems;
  }, [Arr_Invoices_Filtered]);

  let PaidGrossInvoices = Arr_Invoices_Filtered_Sorted.filter(
    (invoice) => invoice.Paid_Status === "Paid" && invoice.GrossOrNet ==="Gross"
  );
 let PaidNetInvoices = Arr_Invoices_Filtered_Sorted.filter(
    (invoice) => invoice.Paid_Status === "Paid" && invoice.GrossOrNet ==="Net"
  );
let UnPaidInvoices = Arr_Invoices_Filtered_Sorted.filter(
  (invoice) => invoice.Paid_Status !== "Paid"
);

  //Given an array of attendees, find sum the value of SubAmount in the Attendees array, where the value of Attendee_id is in the array attendees
  const sumSubAmountByAttendeeIDs = (Invoice) => {
    const attendeeIDs = Arr_Bookings.map((attendee) => attendee._id);
    let totalSubAmount = 0;
    Invoice.Attendees.forEach((attendee) => {
      if (attendeeIDs.includes(attendee.Attendee_id)) {
        totalSubAmount += Number(attendee.SubAmount || 0);
      }
    });
    return totalSubAmount;
  };

console.log("Arr_Bookings")
console.log(Arr_Bookings)
let WebsitePurchasesArr = Arr_Bookings.filter(
    (booking) => booking.OrderInfo && booking.OrderInfo?.LineItemPrice && Number(booking.OrderInfo?.LineItemPrice)>0
);

  //a fucntion that, when given an invoice, which has multiple values in the array called "Attendees", will find all attendees (with that ID in the Arr_Bookings array and return all of their names as one string
  const getAttendeeNames = (invoice) => {
    let Arr_AttendeeNames = [];
    console.log("GET NAMES");
    if (invoice.Attendees) {
      invoice.Attendees.forEach((Attendee) => {
        let obj_Attendee = Arr_Bookings.find(
          (Booking) => Booking._id === Attendee.Attendee_id
        );

        if (obj_Attendee) {
          Arr_AttendeeNames.push(
            (obj_Attendee.BasicInfo?.First_Name || "First Name TBC") +
              " " +
              (obj_Attendee.BasicInfo?.Last_Name || "Last Name TBC")
          );
        }
      });
      return Arr_AttendeeNames.join(", ");
    } else {
      return "";
    }
  };

    //a fucntion that, when given an invoice, which has multiple values in the array called "Attendees", will find all attendees and return the first one
    function getFirstAttendeeName(invoice) {
      if (invoice.Attendees && invoice.Attendees.length > 0) {
        const firstAttendeeId = invoice.Attendees[0].Attendee_id;
        const obj_Attendee = Arr_Bookings.find(
          (Booking) => Booking._id === firstAttendeeId
        );
        if (obj_Attendee) {
          return (obj_Attendee);
        }
      }
      return "Attendee Not Found";
    }



  //A fucntion that when given an Attendee, uses the value of Attendee.IPInfo.EC_ID to find the EC name from Arr_ECs
  const getECName = (Attendee) => {
    let obj_EC = Arr_ECs.find((EC) => EC._id === Attendee.IPInfo?.EC_ID);
    if (obj_EC) {
      return (
        (obj_EC.BasicInfo?.First_Name || "First Name TBC") +
        " " +
        (obj_EC.BasicInfo?.Last_Name || "Last Name TBC")
      );
    } else {
      return "EC Not Found";
    }
  };

  let TotalCommision = Number(((PaidGrossInvoices.reduce((total, invoice) => total + (Number(sumSubAmountByAttendeeIDs(invoice)) || 0), 0) * 0.2))
            +

           ( Number((WebsitePurchasesArr.reduce((total, booking) => total + (Number(booking.OrderInfo?.LineItemPrice) || 0), 0) * 0.2))
          - Number((WebsitePurchasesArr.reduce((total, booking) => total + (Number(booking.OrderInfo?.LineItemDiscount) || 0), 0) * 0.2))
        )
          
          
          ).toFixed(2);


            const [status, setStatus] = useState(false);
            function handleConfirm(e) {
              e.preventDefault();
              setobj_EC({
                ...obj_EC,
                MetaData: { 
                  ...obj_EC.MetaData, 
                  Commision2025: "Yes" 
                }
              });

              let ArrayOfStudents = [];

              Arr_Bookings.forEach((booking) => {
                const fullName = `${booking.BasicInfo?.First_Name || "First Name TBC"} ${booking.BasicInfo?.Last_Name || "Last Name TBC"}`;
                const programmeTitle = booking.BasicInfo?.ProgrammeTitle || "Programme TBC";
                // Website payment
                const websitePayment = Number(booking.OrderInfo?.LineItemPrice) - (Number(booking.OrderInfo?.LineItemDiscount || 0)||0);
                // Paid Gross Invoices for this student
                const paidGrossInvoicesForStudent = PaidGrossInvoices.filter((invoice) =>
                  invoice.Attendees?.some((att) => att.Attendee_id === booking._id)
                );
                const grossInvoiceTotal = paidGrossInvoicesForStudent.reduce(
                  (sum, invoice) => sum + (Number(invoice.Amount) || 0),
                  0
                );
                // Total payments (website + gross invoices)
                const totalPayments = websitePayment + grossInvoiceTotal;

                // Commission (20%)
                const commission = (totalPayments * 0.2).toFixed(2);

                ArrayOfStudents.push([
                  fullName,
                  programmeTitle,
                  `£${totalPayments.toFixed(2)}`,
                  `£${commission}`
                ]);
              });

              let ArrayOfPaymentDetails = [];
              //for every BankingFieldsArr that exists, add it to the array of payment details with the value entered 
              BankingFieldsArr.forEach((field) => {
                ArrayOfPaymentDetails.push([
                  field.Name.replace(/_/g, " "),
                  BankingInfo[field.Name] || "Not Provided"
                ]);
              });

              Consultant_Update_To_MongoDB_By_ID(
                {
                  MetaData: {
                    ...obj_EC.MetaData,
                    Commision2025: "Yes",
                    Commision2025Amount: TotalCommision
                  },
                  BankingInfo: BankingInfo
                },
                "IP",
                "EC",
                setStatus,
                localStorage.getItem("Consultant_id"),
                logoutConsultant
              );
              Consultant_SendEndOfYearCommisionEmail(
                {AgentEmail : obj_EC.BasicInfo?.Email,
                  IPEmail: obj_IP?.Username || "curtis@investin.org",
                CommissionAmount : TotalCommision,
              ArrayOfStudents: ArrayOfStudents,
              ArrayOfPaymentDetails: ArrayOfPaymentDetails
              },
                setStatus,
                localStorage.getItem("Consultant_id"),
                logoutConsultant
              );
            }

            //-----------------------------------------
              const [BankingInfo, setBankingInfo] = useState({});

  function handleBankingInfoChange(e) {
    e.preventDefault();
    setBankingInfo({ ...BankingInfo, [e.target.name]: e.target.value });
  }


  let BankingFieldsArr = [
    {Name: "Account_Name", required: true}, 
    {Name: "Bank", required: true}, 
    {Name: "Branch", required: true},
    {Name: "Address", required: true}, 
    {Name: "GBP_Account_Number", required: false}, 
    {Name: "Sort_Code", required: false}, 
    {Name: "IBAN", required: false},
    {Name: "Swift", required: false}
   ]

   let isReadyToSubmit = BankingFieldsArr.every((field) => {
     return field.required ? BankingInfo[field.Name] : true;
   });

     //--------------------------------------------------




           

  return (
    <div>
      <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css" />
      <link
        rel="stylesheet"
        href="https://www.w3schools.com/lib/w3-theme-black.css"
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />
      <style jsx>{`
        #BookingTable {
          font-family: Arial, Helvetica, sans-serif;
          border-collapse: collapse;
          width: 100%;
        }

        #BookingTable td,
        #BookingTable th {
          border: 1px solid #ddd;
          padding: 8px;
        }

        #BookingTable tr:nth-child(even) {
          background-color: #ffffff;
        }

        #BookingTable tr:hover {
          background-color: #ddd;
        }

        #BookingTable th {
          padding-top: 12px;
          padding-bottom: 12px;
          background-color: #04aa6d;
          color: white;
        }
      `}</style>

      {/* <!-- Bookings --> */}
      <div
        className="w3-row-padding w3-padding-64 w3-theme-l5 w3-center"
        id="Bookings"
        style={{ position: "relative", minHeight: "100vh" }}
      >
        <h1>Your Commision: £{
            TotalCommision}</h1>
        <p>
          Here you can see all of your payemnts.
          <br></br>
          <br></br>
         Gross Invoices and Website Purchases are valid for our commision rate of 20%. Unpaid Invoice and Net Invoices are not.
          <br></br>
          <br></br>
          If you expected to see an invoice, payment or student here and it is not, please contact international@investin.org with your relationships manager CC'd in
          so we can make changes.
        </p>
        <p>If you are happy with your commission, please send an invoice to international@investin.org and we will process this.</p>
        <p>Please ensure all bank details on your invoice are correct and include all needed information such as: Account Name, Bank Name, Branch, Address, GBP Account Number, Sort Code, IBAN and Swift.</p>
        <p><b>   {obj_EC.MetaData?.Admin === "Yes" && "Please note that as an admin, you can see all sales and bookings acoss your agency. Please speak to your colleagues to ensure you do not request the same commision twice. The 'Partner' column identifies which bookings came from which person."}</b></p>
        <h4><b><i>Again, if there are any discrepancies, please let us know via email, international@investin.org and we can make amendments manually.</i></b></h4>
        <br></br>

      
        {obj_EC.MetaData?.Commision2025 === "Yes" ? 
  <div style={{ padding: "20px", backgroundColor: "#e8f5e8", borderRadius: "5px", margin: "20px 0" }}>
    <h3>Thank you for approving your Commission for 2025!</h3>
  </div>
  : 
  <div>
    {/* <Grid container spacing={2}>          
      {BankingFieldsArr.map((field) => (
        <Grid item xs={12} sm={6} md={3} key={field.Name}>
          <TextField
            name={field.Name}
            label={field.Name.replace(/_/g, " ")}
            variant="outlined"
            required={field.required}
            value={BankingInfo[field.Name] || ""}
            onChange={(e) => handleBankingInfoChange(e)}
            InputProps={{
              style: { backgroundColor: "white" }
            }}
            fullWidth
          /> 
        </Grid>
      ))}
    </Grid> */}
    <br />
    {/* <button 
      style={{
        width: "20%", 
        backgroundColor: !isReadyToSubmit ? "lightgrey" : "#4CAF50",
        padding: "10px",
        border: "none",
        borderRadius: "5px",
        cursor: isReadyToSubmit ? "pointer" : "not-allowed"
      }} 
      onClick={(e) => handleConfirm(e)} 
      disabled={!isReadyToSubmit}
    >
      Confirm Commission of £{TotalCommision}
    </button> */}
    <br />
  </div>
}

   

        {/* Breakdowns */}
        <br></br>
        {/* Paid Gross Invoice */}
        {Array.isArray(PaidGrossInvoices) && PaidGrossInvoices.length > 0 && (
       <>
        <h1>Paid Gross Invoices - Commision Due = 20% * £{
            (PaidGrossInvoices.reduce((total, invoice) => total + (Number(sumSubAmountByAttendeeIDs(invoice)) || 0), 0)).toFixed(2)
        } = £{
            (PaidGrossInvoices.reduce((total, invoice) => total + (Number(sumSubAmountByAttendeeIDs(invoice)) || 0), 0) * 0.2).toFixed(2)
        }</h1>
        
        
        <div
      style={{
        overflowX: "scroll",
        overflowY: "auto",
        maxHeight: "calc(100vh - 300px)",
      }}
    >
      <table id="BookingTable">
        <thead>
          <tr>
            {obj_EC.MetaData?.Admin === "Yes" && <th>Partner</th>}
            <th>Invoice Number</th>
            <th>Students</th>
            <th>
              Create Date <i>(dd/mm/yy)</i>
            </th>
            <th>
              Due Date <i>(dd/mm/yy)</i>
            </th>
            <th>Invoice Total</th>
            <th>
              Paid Date <i>(dd/mm/yy)</i>
            </th>
            <th>Invoice Status</th>
            <th>Link</th>
          </tr>
        </thead>
        <tbody>
          {PaidGrossInvoices.map((obj_invoice, index) => (
            <>
              <tr key={index}>
                {obj_EC.MetaData?.Admin === "Yes" && <td>{getECName(getFirstAttendeeName(obj_invoice))}</td>}
                <td>{obj_invoice.Invoice_Number || ""}</td>
                <td>{getAttendeeNames(obj_invoice) || ""}</td>

                <td>
                  {obj_invoice.DateTime
                    ? obj_invoice.DateTime.substring(8, 10) +
                      "/" +
                      obj_invoice.DateTime.substring(5, 7) +
                      "/" +
                      obj_invoice.DateTime.substring(2, 4)
                    : ""}
                </td>
                <td>
                  {obj_invoice.Due_Date
                    ? obj_invoice.Due_Date.substring(8, 10) +
                      "/" +
                      obj_invoice.Due_Date.substring(5, 7) +
                      "/" +
                      obj_invoice.Due_Date.substring(2, 4)
                    : ""}
                </td>
                <td>{sumSubAmountByAttendeeIDs(obj_invoice) ? "£" + sumSubAmountByAttendeeIDs(obj_invoice) : ""}</td>
                {obj_invoice.Paid_Date ? (
                  <td>
                    {obj_invoice.Paid_Date.substring(8, 10)}/
                    {obj_invoice.Paid_Date.substring(5, 7)}/
                    {obj_invoice.Paid_Date.substring(2, 4)}
                  </td>
                ) : (
                  <td style={{ backgroundColor: "grey" }}></td>
                )}
                {obj_invoice.Paid_Status === "Paid" ? (
                  <td style={{ backgroundColor: "#DAF7A6" }}>Paid</td>
                ) : (
                  <td style={{ backgroundColor: "#85c1e9" }}>UnPaid</td>
                )}
                {obj_invoice.Paid_Status === "Paid" ? (
                  <td></td>
                ) : obj_invoice.Link && obj_invoice.Link.length > 0 ? (
                  <td>
                    <button
                      onClick={() => window.open(obj_invoice.Link, "_blank")}
                    >
                      Payment Link
                    </button>
                  </td>
                ) : (
                  <></>
                )}
              </tr>
            </>
          ))}
        </tbody>
      </table>
    </div>
    </>
    )}
    {/* Paid Net Invoices */}
    {Array.isArray(PaidNetInvoices) && PaidNetInvoices.length > 0 && (
       <>
    <h1>Paid Net Invoices - Commision Due = £0.00</h1>
        <div
      style={{
        overflowX: "scroll",
        overflowY: "auto",
        maxHeight: "calc(100vh - 300px)",
      }}
    >
      <table id="BookingTable">
        <thead>
          <tr>
             {obj_EC.MetaData?.Admin === "Yes" && <th>Partner</th>}
            <th>Invoice Number</th>
            <th>Students</th>
            <th>
              Create Date <i>(dd/mm/yy)</i>
            </th>
            <th>
              Due Date <i>(dd/mm/yy)</i>
            </th>
            <th>Invoice Total</th>
            <th>
              Paid Date <i>(dd/mm/yy)</i>
            </th>
            <th>Invoice Status</th>
            
          </tr>
        </thead>
        <tbody>
          {PaidNetInvoices.map((obj_invoice, index) => (
            <>
              <tr key={index}>
                                {obj_EC.MetaData?.Admin === "Yes" && <td>{getECName(getFirstAttendeeName(obj_invoice))}</td>}

                <td>{obj_invoice.Invoice_Number || ""}</td>
                <td>{getAttendeeNames(obj_invoice) || ""}</td>

                <td>
                  {obj_invoice.DateTime
                    ? obj_invoice.DateTime.substring(8, 10) +
                      "/" +
                      obj_invoice.DateTime.substring(5, 7) +
                      "/" +
                      obj_invoice.DateTime.substring(2, 4)
                    : ""}
                </td>
                <td>
                  {obj_invoice.Due_Date
                    ? obj_invoice.Due_Date.substring(8, 10) +
                      "/" +
                      obj_invoice.Due_Date.substring(5, 7) +
                      "/" +
                      obj_invoice.Due_Date.substring(2, 4)
                    : ""}
                </td>
                <td>{sumSubAmountByAttendeeIDs(obj_invoice) ? "£" + sumSubAmountByAttendeeIDs(obj_invoice) : ""}</td>
                {obj_invoice.Paid_Date ? (
                  <td>
                    {obj_invoice.Paid_Date.substring(8, 10)}/
                    {obj_invoice.Paid_Date.substring(5, 7)}/
                    {obj_invoice.Paid_Date.substring(2, 4)}
                  </td>
                ) : (
                  <td style={{ backgroundColor: "grey" }}></td>
                )}
                {obj_invoice.Paid_Status === "Paid" ? (
                  <td style={{ backgroundColor: "#DAF7A6" }}>Paid</td>
                ) : (
                  <td style={{ backgroundColor: "#85c1e9" }}>UnPaid</td>
                )}
                {obj_invoice.Paid_Status === "Paid" ? (
                  <td></td>
                ) : obj_invoice.Link && obj_invoice.Link.length > 0 ? (
                  <td>
                    <button
                      onClick={() => window.open(obj_invoice.Link, "_blank")}
                    >
                      Payment Link
                    </button>
                  </td>
                ) : (
                  <></>
                )}
              </tr>
            </>
          ))}
        </tbody>
      </table>
    </div>
    </>)}
    {/* UnPaid Invoices */}
    {Array.isArray(UnPaidInvoices) && UnPaidInvoices.length > 0 && (
       <>
    <h1>UnPaid Invoices- Commision Due Only After Payment</h1>
        <div
      style={{
        overflowX: "scroll",
        overflowY: "auto",
        maxHeight: "calc(100vh - 300px)",
      }}
    >
      <table id="BookingTable">
        <thead>
          <tr>
                         {obj_EC.MetaData?.Admin === "Yes" && <th>Partner</th>}

            <th>Invoice Number</th>
            <th>Students</th>
            <th>
              Create Date <i>(dd/mm/yy)</i>
            </th>
            <th>
              Due Date <i>(dd/mm/yy)</i>
            </th>
            <th>Invoice Total</th>
            <th>
              Paid Date <i>(dd/mm/yy)</i>
            </th>
            <th>Invoice Status</th>
          </tr>
        </thead>
        <tbody>
          {UnPaidInvoices.map((obj_invoice, index) => (
            <>
              <tr key={index}>
              {obj_EC.MetaData?.Admin === "Yes" && <td>{getECName(getFirstAttendeeName(obj_invoice))}</td>}

                <td>{obj_invoice.Invoice_Number || ""}</td>
                <td>{getAttendeeNames(obj_invoice) || ""}</td>

                <td>
                  {obj_invoice.DateTime
                    ? obj_invoice.DateTime.substring(8, 10) +
                      "/" +
                      obj_invoice.DateTime.substring(5, 7) +
                      "/" +
                      obj_invoice.DateTime.substring(2, 4)
                    : ""}
                </td>
                <td>
                  {obj_invoice.Due_Date
                    ? obj_invoice.Due_Date.substring(8, 10) +
                      "/" +
                      obj_invoice.Due_Date.substring(5, 7) +
                      "/" +
                      obj_invoice.Due_Date.substring(2, 4)
                    : ""}
                </td>
                <td>{obj_invoice.Amount ? "£" + obj_invoice.Amount : ""}</td>
                {obj_invoice.Paid_Date ? (
                  <td>
                    {obj_invoice.Paid_Date.substring(8, 10)}/
                    {obj_invoice.Paid_Date.substring(5, 7)}/
                    {obj_invoice.Paid_Date.substring(2, 4)}
                  </td>
                ) : (
                  <td style={{ backgroundColor: "grey" }}></td>
                )}
                {obj_invoice.Paid_Status === "Paid" ? (
                  <td style={{ backgroundColor: "#DAF7A6" }}>Paid</td>
                ) : (
                  <td style={{ backgroundColor: "#85c1e9" }}>UnPaid</td>
                )}
                {obj_invoice.Paid_Status === "Paid" ? (
                  <td></td>
                ) : obj_invoice.Link && obj_invoice.Link.length > 0 ? (
                  <td>
                    <button
                      onClick={() => window.open(obj_invoice.Link, "_blank")}
                    >
                      Payment Link
                    </button>
                  </td>
                ) : (
                  <></>
                )}
              </tr>
            </>
          ))}
        </tbody>
      </table>
    </div></>
    )}
    {console.log("WebsitePurchasesArr", WebsitePurchasesArr)}
    {/* Website Purchases */}
    {Array.isArray(WebsitePurchasesArr) && WebsitePurchasesArr.length > 0 && (
       <>
        <h1>Website Purchases - Commision Due = 20% * £{
            ((WebsitePurchasesArr.reduce((total, booking) => total + (Number(booking.OrderInfo?.LineItemPrice) || 0), 0))
            -
            (WebsitePurchasesArr.reduce((total, booking) => total + (Number(booking.OrderInfo?.LineItemDiscount) || 0), 0)))
            .toFixed(2)
        } = £{
            (
              (WebsitePurchasesArr.reduce((total, booking) => total + (Number(booking.OrderInfo?.LineItemPrice) || 0), 0)
              -
              WebsitePurchasesArr.reduce((total, booking) => total + (Number(booking.OrderInfo?.LineItemDiscount) || 0), 0))
              
              
              * 0.2).toFixed(2)
        }</h1>
        <div
      style={{
        overflowX: "scroll",
        overflowY: "auto",
        maxHeight: "calc(100vh - 300px)",
      }}
    >
      <table id="BookingTable">
        <thead>
          <tr>
        {obj_EC.MetaData?.Admin === "Yes" && <th>Partner</th>}
         <th>Created At</th>
        <th>Original Order_Number</th>
          <th>Gross Amount</th>
          </tr>
        </thead>
        <tbody>
          {WebsitePurchasesArr.map((obj_shopify, index) => (
            <>
              <tr key={index}>
                 {obj_EC.MetaData?.Admin === "Yes" && <td>{getECName(obj_shopify)}</td>}
                <td>{obj_shopify.BasicInfo?.Created_At}</td>
                <td>{obj_shopify.OrderInfo?.OriginalOrderNumber}</td>
                <td>£{(obj_shopify.OrderInfo?.LineItemPrice) - (obj_shopify.OrderInfo?.LineItemDiscount || 0)}</td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
    </div>
    </>)}
    {/* Done */}
      </div>

      {/* <!-- Footer --> */}
      <footer className="w3-container w3-padding-32 w3-theme-d1 w3-center">
        <h4>Follow Us</h4>
        <a
          className="w3-button w3-large w3-teal"
          href="https://www.facebook.com/@investineducation/"
          title="Facebook"
        >
          <i className="fa fa-facebook"></i>
        </a>
        <a
          className="w3-button w3-large w3-teal"
          href="https://twitter.com/investin_ed"
          title="Twitter"
        >
          <i className="fa fa-twitter"></i>
        </a>

        <a
          className="w3-button w3-large w3-teal"
          href="https://www.instagram.com/investin_education/?hl=en"
          title="Instagram"
        >
          <i className="fa fa-instagram"></i>
        </a>
        <a
          className="w3-button w3-large w3-teal w3-hide-small"
          href="https://uk.linkedin.com/company/investin"
          title="Linkedin"
        >
          <i className="fa fa-linkedin"></i>
        </a>
        <a
          className="w3-button w3-large w3-teal"
          href="https://investin.org/"
          title="Website"
        >
          <i className="fa fa-globe"></i>
        </a>
      </footer>
    </div>
  );
};

export default EndOfYear;
